/**
 * What a paid plan costs now, read from the Stripe catalog (tasks 413, 402).
 *
 * `infra/stripe/catalog.json` is what Terraform makes the Stripe prices from,
 * so every page that prints a price reads that file rather than restating the
 * amounts. It lives outside this package, so each app imports the JSON itself
 * and passes it here: the marketing site's pricing page and the dashboard's
 * onboarding cards then read one file through one rule, and the dashboard no
 * longer keeps a typed copy of every price (task 402).
 *
 * The catalog keeps every price a plan has been sold at, so that Terraform
 * goes on managing the ones subscribers still pay; the current one is the one
 * not `retired`, which holds the lookup key checkout charges.
 */
/**
 * A paid plan's current price for the interval, in whole dollars. Throws
 * unless the catalog has exactly one current price for it, which is also what
 * Terraform's own validation requires.
 */
export function catalogPrice(catalog, plan, interval) {
    const current = (catalog.plans[plan]?.prices ?? []).filter((price) => price.interval === interval && !price.retired);
    const [price] = current;
    if (!price || current.length > 1) {
        throw new Error(`infra/stripe/catalog.json needs exactly one current ${interval} price for ${plan}`);
    }
    return price.amount / 100;
}
//# sourceMappingURL=catalog-price.js.map